import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  CaptionText,
} from "../../components/typography";
import { useEffect } from "react";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { COLORS } from "../../assets/utils/enums/colors";
import { motion } from "framer-motion";

export default function MainFinancePage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/finance") {
      navigate("/finance/income", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <AppLayout className="" blockType="projects" loaderState={false}>
      <Headline
        headline={HeadlineTypeEnum.FINANCE}
        theme={ThemeTypeEnum.LIGHT}
      />
      <TabList>
        <StyledTab
          to="/finance/income"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Надходження
          {location.pathname === "/finance/income" && (
            <Underline layoutId="underline" />
          )}
        </StyledTab>

        <StyledTab
          to="/finance/expense"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Витрати
          {location.pathname === "/finance/expense" && (
            <Underline layoutId="underline" />
          )}
        </StyledTab>
      </TabList>

      <Outlet />
    </AppLayout>
  );
}

const TabList = styled.div`
  display: flex;
  border-bottom: 2px solid ${COLORS["light-bg-color"]};
  flex-grow: 1;
`;

const StyledTab = styled(NavLink)`
  position: relative;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 500;
  color: ${COLORS["bg-text-color"]};
  border-radius: 8px;
  background: transparent;
  text-decoration: none;
  text-align: center;
  ${CaptionText.componentStyle.rules.join("")}
  flex: 1;
  transition: color 0.3s ease;

  &.active {
    color: ${COLORS.secondary1};
  }

  &:hover {
    color: ${COLORS.blue};
  }
`;

const Underline = styled(motion.div)`
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: ${COLORS.secondary1};
  border-radius: 20px;
`;
